import { ButtonGroup, IconButton } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";

type Props = {
  deleteItem: (itemId: number) => void;
  onEdit: (itemId: number) => void;
  id: number;
  hide?: boolean;
  showEdit?: boolean;
};

export const EditAndDeleteButtons = ({
  deleteItem,
  onEdit,
  id,
  hide,
  showEdit = true,
}: Props) => {
  if (hide) {
    return null;
  }

  return (
    <>
      <ButtonGroup>
        {showEdit && onEdit && (
          <IconButton
            color={"primary"}
            onClick={() => {
              onEdit(id);
            }}
            title="Edit"
          >
            <EditIcon style={{ cursor: "pointer" }} fontSize="small" />
          </IconButton>
        )}
        {deleteItem ? (
          <IconButton
            color={"secondary"}
            onClick={() => {
              deleteItem(id);
            }}
            title="Delete"
          >
            <DeleteIcon style={{ cursor: "pointer" }} fontSize="small" />
          </IconButton>
        ) : null}
      </ButtonGroup>
    </>
  );
};
